"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var InlineSvg = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InlineSvg, _React$Component);

  function InlineSvg() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InlineSvg.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        name = _this$props.name,
        _this$props$colour = _this$props.colour,
        colour = _this$props$colour === void 0 ? 'cyan' : _this$props$colour;
    var colourHex;

    switch (colour) {
      case 'cyan':
        colourHex = '#00aec7';
        break;

      case 'deepCyan':
        colourHex = '#0f849e';
        break;

      case 'teal':
        colourHex = '#00b398';
        break;

      case 'blue':
        colourHex = '#004b87';
        break;

      case 'white':
        colourHex = '#ffffff';
        break;

      case 'lightCyan':
        colourHex = '#7FD1E3';
        break;

      case 'grey':
        colourHex = '#646F80';
        break;

      case 'paleSky':
        colourHex = '#646F80';
        break;

      default:
        colourHex = '#00aec7';
      // cyan
    }

    switch (name) {
      case 'gear':
        return /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M24 13.616v-3.232c-1.651-.587-2.694-.752-3.219-2.019v-.001c-.527-1.271.1-2.134.847-3.707l-2.285-2.285c-1.561.742-2.433 1.375-3.707.847h-.001c-1.269-.526-1.435-1.576-2.019-3.219h-3.232c-.582 1.635-.749 2.692-2.019 3.219h-.001c-1.271.528-2.132-.098-3.707-.847l-2.285 2.285c.745 1.568 1.375 2.434.847 3.707-.527 1.271-1.584 1.438-3.219 2.02v3.232c1.632.58 2.692.749 3.219 2.019.53 1.282-.114 2.166-.847 3.707l2.285 2.286c1.562-.743 2.434-1.375 3.707-.847h.001c1.27.526 1.436 1.579 2.019 3.219h3.232c.582-1.636.75-2.69 2.027-3.222h.001c1.262-.524 2.12.101 3.698.851l2.285-2.286c-.744-1.563-1.375-2.433-.848-3.706.527-1.271 1.588-1.44 3.221-2.021zm-12 2.384c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z",
          fill: colourHex
        }));

      case 'logout':
        return /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M16 9v-4l8 7-8 7v-4h-8v-6h8zm-16-7v20h14v-2h-12v-16h12v-2h-14z",
          fill: colourHex
        }));

      case 'nineDot':
        return /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "38",
          height: "38",
          viewBox: "0 0 38 38"
        }, /*#__PURE__*/React.createElement("g", {
          fill: "none",
          fillRule: "evenodd"
        }, /*#__PURE__*/React.createElement("rect", {
          width: "38",
          height: "38",
          fill: "#646F80",
          rx: "2"
        }), /*#__PURE__*/React.createElement("path", {
          stroke: "#FFF",
          strokeLinecap: "square",
          strokeWidth: "3",
          d: "M12 1.49642875L12 36.5M26 .496621776L26 37.5M36.5033332 26L.496528267 26M36.5034717 13L.496666815 13",
          fill: colourHex
        })));

      case 'userIcon':
        return /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm7.753 18.305c-.261-.586-.789-.991-1.871-1.241-2.293-.529-4.428-.993-3.393-2.945 3.145-5.942.833-9.119-2.489-9.119-3.388 0-5.644 3.299-2.489 9.119 1.066 1.964-1.148 2.427-3.393 2.945-1.084.25-1.608.658-1.867 1.246-1.405-1.723-2.251-3.919-2.251-6.31 0-5.514 4.486-10 10-10s10 4.486 10 10c0 2.389-.845 4.583-2.247 6.305z",
          fill: colourHex
        }));

      case 'dropDownArrow':
        return /*#__PURE__*/React.createElement("svg", {
          className: this.props.className,
          xmlns: "http://www.w4.org/2000/svg",
          width: "16",
          height: "8",
          viewBox: "0 0 16 8"
        }, /*#__PURE__*/React.createElement("polygon", {
          fill: "#D0D5DC",
          fillRule: "evenodd",
          points: "1565 59 1573 67 1557 67",
          transform: "matrix(-1 0 0 1 1573 -59)"
        }));

      case 'question':
        return /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          className: this.props.className
        }, /*#__PURE__*/React.createElement("path", {
          fill: colourHex,
          d: "M14.601 21.5c0 1.38-1.116 2.5-2.499 2.5-1.378 0-2.499-1.12-2.499-2.5s1.121-2.5 2.499-2.5c1.383 0 2.499 1.119 2.499 2.5zm-2.42-21.5c-4.029 0-7.06 2.693-7.06 8h3.955c0-2.304.906-4.189 3.024-4.189 1.247 0 2.57.828 2.684 2.411.123 1.666-.767 2.511-1.892 3.582-2.924 2.78-2.816 4.049-2.816 7.196h3.943c0-1.452-.157-2.508 1.838-4.659 1.331-1.436 2.986-3.222 3.021-5.943.047-3.963-2.751-6.398-6.697-6.398z"
        }));

      case 'close':
        return /*#__PURE__*/React.createElement("svg", {
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          clipRule: "evenodd",
          className: this.props.className
        }, /*#__PURE__*/React.createElement("path", {
          fill: colourHex,
          d: "M12 11.293l10.293-10.293.707.707-10.293 10.293 10.293 10.293-.707.707-10.293-10.293-10.293 10.293-.707-.707 10.293-10.293-10.293-10.293.707-.707 10.293 10.293z"
        }));

      case 'bag':
        return /*#__PURE__*/React.createElement("svg", {
          width: "20",
          height: "23",
          viewBox: "0 0 20 23",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M15.23 6.8763L15.2301 5.5013C15.2304 2.46856 12.7953 0.00110716 9.802 0.000871138C6.80865 0.000635115 4.37324 2.46771 4.373 5.50044L4.37289 6.87544L0.30146 6.87512L0.300538 18.5626C0.300389 20.4611 1.81929 22.0002 3.69312 22.0004L15.9074 22.0014C17.7812 22.0015 19.3004 20.4626 19.3005 18.5641L19.3015 6.87662L15.23 6.8763ZM7.08728 5.50066C7.0874 3.98429 8.30511 2.75075 9.80179 2.75087C11.2985 2.75099 12.516 3.98472 12.5159 5.50109L12.5157 6.87609L7.08717 6.87566L7.08728 5.50066ZM13.8726 10.6574C13.3104 10.6574 12.8548 10.1957 12.8548 9.62611C12.8549 9.05656 13.3106 8.5949 13.8728 8.59494C14.4349 8.59499 14.8906 9.05672 14.8905 9.62627C14.8905 10.1958 14.4347 10.6575 13.8726 10.6574ZM5.72973 10.6568C5.16758 10.6568 4.71191 10.195 4.71196 9.62547C4.712 9.05592 5.16774 8.59426 5.7299 8.5943C6.29205 8.59434 6.74772 9.05608 6.74767 9.62563C6.74763 10.1952 6.29189 10.6568 5.72973 10.6568Z",
          fill: colourHex
        }));

      case 'brush':
        return /*#__PURE__*/React.createElement("svg", {
          width: "23",
          height: "23",
          viewBox: "0 0 23 23",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M19.8511 0.00156509C20.4247 0.00161032 20.9265 0.191941 21.3567 0.572556C21.7868 0.95317 22.0018 1.42993 22.0018 2.00285C22.0018 2.51848 21.8173 3.13639 21.4486 3.8566C18.7279 9.00445 16.8226 12.0817 15.7328 13.0883C14.9379 13.833 14.0448 14.2053 13.0533 14.2053C12.0209 14.2052 11.134 13.8266 10.3925 13.0695C9.65108 12.3123 9.28038 11.4141 9.28046 10.3746C9.28055 9.327 9.65752 8.45947 10.4114 7.77203L18.2533 0.664386C18.7368 0.22246 19.2694 0.00151922 19.8511 0.00156509ZM8.67805 12.6949C8.99755 13.3169 9.43382 13.849 9.98686 14.291C10.5399 14.733 11.1564 15.044 11.8365 15.2241L11.8487 16.0958C11.8814 17.8391 11.3507 19.2591 10.2568 20.3557C9.16283 21.4524 7.73504 22.0006 5.9734 22.0005C4.96558 22.0004 4.07249 21.81 3.29412 21.4294C2.51575 21.0487 1.89102 20.5269 1.41994 19.864C0.948857 19.201 0.594539 18.4521 0.356989 17.6172C0.119438 16.7824 0.000700836 15.8821 0.000776986 14.9163C0.0581294 14.9572 0.22609 15.08 0.504659 15.2846C0.783227 15.4893 1.03722 15.6714 1.26663 15.831C1.49604 15.9906 1.73774 16.14 1.99173 16.2792C2.24572 16.4183 2.43417 16.4879 2.55708 16.4879C2.89302 16.488 3.11836 16.3366 3.23309 16.0337C3.43798 15.4936 3.67358 15.0332 3.9399 14.6527C4.20623 14.2721 4.49098 13.9611 4.79417 13.7197C5.09735 13.4783 5.45789 13.2839 5.87578 13.1366C6.29367 12.9893 6.71565 12.885 7.14172 12.8237C7.5678 12.7623 8.07991 12.7194 8.67805 12.6949Z",
          fill: colourHex
        }));

      case 'car':
        return /*#__PURE__*/React.createElement("svg", {
          width: "22",
          height: "16",
          viewBox: "0 0 22 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M18.6678 5.56695L18.1178 5.56691L14.3789 0.836653C14.1727 0.575959 13.9113 0.365502 13.6139 0.220854C13.3166 0.076206 12.9908 0.00106856 12.6609 0.0010008L5.30773 0.000421013C4.40814 0.000350081 3.59925 0.554399 3.26506 1.39963L1.61782 5.64422C0.670422 5.8925 -0.0322709 6.75545 -0.0323526 7.79167L-0.0326598 11.6875C-0.0326841 11.995 0.213421 12.2441 0.517296 12.2441L2.1673 12.2442C2.16715 14.0885 3.64447 15.5836 5.46703 15.5838C7.2896 15.5839 8.76715 14.089 8.7673 12.2447L13.1673 12.2451C13.1672 14.0894 14.6445 15.5845 16.467 15.5846C18.2896 15.5848 19.7672 14.0899 19.7673 12.2456L21.4173 12.2457C21.7212 12.2458 21.9673 11.9967 21.9673 11.6892L21.9676 8.9065C21.9677 7.06224 20.4904 5.5671 18.6678 5.56695ZM5.46716 13.9141C4.55726 13.9141 3.81722 13.1651 3.8173 12.2444C3.81737 11.3236 4.55752 10.5748 5.46743 10.5748C6.37733 10.5749 7.11737 11.3239 7.1173 12.2446C7.11722 13.1654 6.37707 13.9142 5.46716 13.9141ZM7.94282 5.56611L3.98729 5.56579L5.30756 2.22661L7.94309 2.22682L7.94282 5.56611ZM9.59282 5.56624L9.59309 2.22695L12.6607 2.22719L15.3004 5.56669L9.59282 5.56624ZM16.4672 13.915C15.5573 13.9149 14.8172 13.166 14.8173 12.2452C14.8174 11.3245 15.5575 10.5756 16.4674 10.5757C17.3773 10.5758 18.1174 11.3247 18.1173 12.2455C18.1172 13.1662 17.3771 13.9151 16.4672 13.915Z",
          fill: colourHex
        }));

      case 'people':
        return /*#__PURE__*/React.createElement("svg", {
          width: "23",
          height: "23",
          viewBox: "0 0 23 23",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M17.5882 21.0433C17.5884 18.5727 15.1828 17.3152 12.8399 16.3052C10.5047 15.2996 9.75892 14.4526 9.75907 12.6376C9.75915 11.5497 10.4719 11.9039 10.7845 9.90856C10.9165 9.08137 11.5457 9.89542 11.6668 8.00673C11.6669 7.25432 11.3226 7.0673 11.3226 7.0673C11.3226 7.0673 11.4976 5.95301 11.5659 5.09502C11.6363 4.19632 11.1283 2.27898 9.03503 1.69032C8.66986 1.31519 8.42241 0.720069 9.54885 0.123958C7.08486 0.00936323 6.51166 1.29852 5.19929 2.24661C4.08272 3.07813 3.78122 4.3948 3.83506 5.09551C3.90649 5.95351 4.08021 7.06783 4.08021 7.06783C4.08021 7.06783 3.73479 7.2548 3.73473 8.0072C3.85558 9.89701 4.48705 9.08196 4.61788 9.90917C4.93012 11.9046 5.64405 11.5505 5.64397 12.6384C5.64382 14.4534 5.41057 15.0693 3.07409 16.0745C0.729915 17.0831 0.000487797 18.7 0.0124031 21.0419C0.0156479 21.7426 0.000227594 22 0.000227594 22L17.6002 22.0014C17.6002 22.0014 17.5881 21.744 17.5882 21.0433ZM20.3816 14.7031C19.1331 14.2003 18.6162 13.6008 18.6163 12.4304C18.6163 11.7253 19.0761 11.9552 19.2786 10.6671C19.3634 10.1347 19.7703 10.6584 19.8485 9.44067C19.8486 8.95557 19.6264 8.83455 19.6264 8.83455C19.6264 8.83455 19.7397 8.11296 19.7838 7.55967C19.8388 6.86997 19.3836 5.08793 17.2892 5.08777C15.1959 5.0876 14.7392 6.86957 14.7931 7.55927C14.8392 8.11148 14.9514 8.83418 14.9514 8.83418C14.9514 8.83418 14.7292 8.95407 14.7291 9.44027C14.8071 10.658 15.2142 10.1344 15.2988 10.6668C15.5011 11.956 15.9609 11.7262 15.9609 12.4302C15.9608 13.6006 15.4789 14.1483 13.9708 14.7972C13.8949 14.8291 13.8388 14.872 13.7695 14.9094C15.5734 15.6927 18.4179 17.0449 19.0909 19.8015L22.0004 19.8017C22.0004 19.8017 22.0006 17.7051 22.0006 17.2519C22.0007 16.1519 21.7005 15.2345 20.3816 14.7031Z",
          fill: colourHex
        }));

      case 'pram':
        return /*#__PURE__*/React.createElement("svg", {
          width: "21",
          height: "23",
          viewBox: "0 0 21 23",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M12.1354 0.000954076L12.1347 8.80095L20.9347 8.80165C20.9351 3.93965 16.9974 0.00133744 12.1354 0.000954076ZM19.0862 15.2805C20.2413 13.7956 20.9345 11.9256 20.9346 9.90165L4.91862 9.90039L3.87379 7.7003L0.0347933 7.7L0.0346198 9.9L2.47662 9.90019C2.47662 9.90019 4.55527 14.3774 4.80824 14.7624C3.59819 15.4113 2.78408 16.6872 2.78397 18.1502C2.7838 20.2732 4.51067 22.0004 6.63367 22.0005C8.56967 22.0007 10.1758 20.5708 10.4399 18.7008L12.7279 18.701C12.9918 20.571 14.5977 22.0011 16.5337 22.0013C18.6567 22.0015 20.3838 20.2746 20.384 18.1516C20.3841 17.0076 19.8781 15.9846 19.0862 15.2805ZM6.63384 19.8005C5.72084 19.8004 4.9839 19.0634 4.98397 18.1504C4.98404 17.2374 5.7211 16.5004 6.6341 16.5005C7.5471 16.5006 8.28404 17.2377 8.28397 18.1507C8.2839 19.0637 7.54684 19.8006 6.63384 19.8005ZM16.5338 19.8013C15.6208 19.8012 14.8839 19.0642 14.884 18.1512C14.884 17.2382 15.6211 16.5012 16.5341 16.5013C17.4471 16.5014 18.184 17.2384 18.184 18.1514C18.1839 19.0644 17.4468 19.8014 16.5338 19.8013Z",
          fill: colourHex
        }));

      case 'star':
        return /*#__PURE__*/React.createElement("svg", {
          width: "23",
          height: "22",
          viewBox: "0 0 23 22",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M17.1129 20.9959C16.9366 20.9966 16.7627 20.9549 16.6058 20.8744L10.984 17.9243L5.36176 20.8735C5.17919 20.9697 4.97336 21.0126 4.76766 20.9974C4.56196 20.9822 4.36465 20.9094 4.19815 20.7874C4.03165 20.6654 3.90264 20.4991 3.8258 20.3072C3.74895 20.1154 3.72734 19.9058 3.76343 19.7023L4.86628 13.4827L0.324923 9.06342C0.183235 8.9217 0.0827293 8.74399 0.0341926 8.54936C-0.014344 8.35473 -0.00907951 8.15052 0.0494211 7.95866C0.113329 7.76233 0.230872 7.58788 0.388711 7.4551C0.54655 7.32233 0.738365 7.23656 0.942389 7.20751L7.22589 6.29107L9.99325 0.623982C10.0835 0.43721 10.2245 0.2797 10.4 0.169496C10.5754 0.0592912 10.7783 0.000849709 10.9854 0.000866038C11.1925 0.000882366 11.3954 0.0593558 11.5709 0.169588C11.7463 0.27982 11.8872 0.437352 11.9775 0.624138L14.777 6.28062L21.0604 7.19805C21.2644 7.22713 21.4562 7.31293 21.614 7.44573C21.7718 7.57853 21.8894 7.753 21.9532 7.94934C22.0117 8.14121 22.0169 8.34542 21.9684 8.54004C21.9198 8.73466 21.8193 8.91236 21.6776 9.05406L17.1355 13.4727L18.2374 19.6924C18.2767 19.8995 18.2561 20.1136 18.1779 20.3094C18.0998 20.5051 17.9674 20.6744 17.7963 20.7971C17.5967 20.9373 17.3564 21.0072 17.1129 20.9959Z",
          fill: colourHex
        }));

      case 'file':
        return /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "50",
          height: "61",
          viewBox: "0 0 50 61",
          fill: "none"
        }, /*#__PURE__*/React.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 61H22.5C33 61 50 44.5 50 35.7374V0H0V61ZM30.5 47.5V41H31H38C40.3333 40.8333 45 39.2 45 34V5H5V54.5H23.5C28.7 54.5 30.3333 49.8333 30.5 47.5ZM38 15H13V18H38V15ZM13 22H38V25H13V22ZM38 30H13V33H38V30Z",
          fill: colourHex
        }));

      case 'target':
        return /*#__PURE__*/React.createElement("svg", {
          width: "23",
          height: "23",
          viewBox: "0 0 23 23",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React.createElement("g", {
          clipPath: "url(#clip0)"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M11.0004 20.1676C16.063 20.168 20.1674 16.0642 20.1678 11.0016C20.1682 5.939 16.0645 1.83462 11.0019 1.83422C5.93926 1.83382 1.83488 5.93755 1.83448 11.0002C1.83408 16.0628 5.93782 20.1672 11.0004 20.1676Z",
          stroke: colourHex,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/React.createElement("path", {
          d: "M11.0006 16.5009C14.0382 16.5012 16.5008 14.0389 16.501 11.0014C16.5013 7.96379 14.039 5.50116 11.0015 5.50092C7.9639 5.50068 5.50127 7.96292 5.50103 11.0005C5.50079 14.0381 7.96303 16.5007 11.0006 16.5009Z",
          stroke: colourHex,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/React.createElement("path", {
          d: "M11.001 12.8342C12.0135 12.8342 12.8344 12.0135 12.8345 11.001C12.8346 9.98846 12.0138 9.16758 11.0013 9.1675C9.98878 9.16742 9.1679 9.98817 9.16782 11.0007C9.16774 12.0132 9.98849 12.8341 11.001 12.8342Z",
          stroke: colourHex,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
          id: "clip0"
        }, /*#__PURE__*/React.createElement("rect", {
          width: "22",
          height: "22",
          fill: "white",
          transform: "translate(0.00195312)"
        }))));

      case 'creative':
        return /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: colourHex
        }, /*#__PURE__*/React.createElement("path", {
          d: "M4 21.832c4.587.38 2.944-4.493 7.188-4.538l1.838 1.534c.458 5.538-6.315 6.773-9.026 3.004zm14.065-7.115c1.427-2.239 5.847-9.749 5.847-9.749.352-.623-.43-1.273-.976-.813 0 0-6.572 5.714-8.511 7.525-1.532 1.432-1.539 2.086-2.035 4.447l1.68 1.4c2.227-.915 2.868-1.039 3.995-2.81zm-11.999 3.876c.666-1.134 1.748-2.977 4.447-3.262.434-2.087.607-3.3 2.547-5.112 1.373-1.282 4.938-4.409 7.021-6.229-1-2.208-4.141-4.023-8.178-3.99-6.624.055-11.956 5.465-11.903 12.092.023 2.911 1.081 5.571 2.82 7.635 1.618.429 2.376.348 3.246-1.134zm6.952-15.835c1.102-.006 2.005.881 2.016 1.983.004 1.103-.882 2.009-1.986 2.016-1.105.009-2.008-.88-2.014-1.984-.013-1.106.876-2.006 1.984-2.015zm-5.997 2.001c1.102-.01 2.008.877 2.012 1.983.012 1.106-.88 2.005-1.98 2.016-1.106.007-2.009-.881-2.016-1.988-.009-1.103.877-2.004 1.984-2.011zm-2.003 5.998c1.106-.007 2.01.882 2.016 1.985.01 1.104-.88 2.008-1.986 2.015-1.105.008-2.005-.88-2.011-1.985-.011-1.105.879-2.004 1.981-2.015zm10.031 8.532c.021 2.239-.882 3.718-1.682 4.587l-.046.044c5.255-.591 9.062-4.304 6.266-7.889-1.373 2.047-2.534 2.442-4.538 3.258z"
        }));

      case 'megaphone':
        return /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: colourHex
        }, /*#__PURE__*/React.createElement("path", {
          d: "M4.967 15c-2.743 0-4.967-2.238-4.967-5 0-2.761 2.224-5 4.967-5h5.033v10h-5.033zm7.04 7.475c-.52-.424-.902-.994-1.095-1.637l-1.151-3.827h-5.125l1.905 5.883c.214.659.828 1.106 1.521 1.106h3.439c.358 0 .677-.225.797-.562.12-.337.015-.713-.263-.939l-.028-.024zm-.007-17.475v10c3.164.509 7.161 1.992 12 5v-20c-4.964 3.085-8.876 4.502-12 5z"
        }));

      case 'document':
        return /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: colourHex
        }, /*#__PURE__*/React.createElement("path", {
          d: "M13.744 8s1.522-8-3.335-8h-8.409v24h20v-13c0-3.419-5.247-3.745-8.256-3zm4.256 11h-12v-1h12v1zm0-3h-12v-1h12v1zm0-3h-12v-1h12v1zm-3.432-12.925c2.202 1.174 5.938 4.883 7.432 6.881-1.286-.9-4.044-1.657-6.091-1.179.222-1.468-.185-4.534-1.341-5.702z"
        }));

      case 'paperplane':
        return /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: colourHex
        }, /*#__PURE__*/React.createElement("path", {
          d: "M24 0l-6 22-8.129-7.239 7.802-8.234-10.458 7.227-7.215-1.754 24-12zm-15 16.668v7.332l3.258-4.431-3.258-2.901z"
        }));

      case 'fire':
        return /*#__PURE__*/React.createElement("svg", {
          width: "24",
          height: "24",
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: colourHex
        }, /*#__PURE__*/React.createElement("path", {
          d: "M8.625 0c.61 7.189-5.625 9.664-5.625 15.996 0 4.301 3.069 7.972 9 8.004 5.931.032 9-4.414 9-8.956 0-4.141-2.062-8.046-5.952-10.474.924 2.607-.306 4.988-1.501 5.808.07-3.337-1.125-8.289-4.922-10.378zm4.711 13c3.755 3.989 1.449 9-1.567 9-1.835 0-2.779-1.265-2.769-2.577.019-2.433 2.737-2.435 4.336-6.423z"
        }));

      case 'key':
        return /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: colourHex
        }, /*#__PURE__*/React.createElement("path", {
          d: "M12.451 17.337l-2.451 2.663h-2v2h-2v2h-6v-5l6.865-6.949c1.08 2.424 3.095 4.336 5.586 5.286zm11.549-9.337c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-3-3c0-1.104-.896-2-2-2s-2 .896-2 2 .896 2 2 2 2-.896 2-2z"
        }));

      case 'envelope':
        return /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: colourHex
        }, /*#__PURE__*/React.createElement("path", {
          d: "M12 12.713l-11.985-9.713h23.971l-11.986 9.713zm-5.425-1.822l-6.575-5.329v12.501l6.575-7.172zm10.85 0l6.575 7.172v-12.501l-6.575 5.329zm-1.557 1.261l-3.868 3.135-3.868-3.135-8.11 8.848h23.956l-8.11-8.848z"
        }));

      case 'stats':
        return /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: colourHex
        }, /*#__PURE__*/React.createElement("path", {
          d: "M7 24h-6v-6h6v6zm8-9h-6v9h6v-9zm8-4h-6v13h6v-13zm0-11l-6 1.221 1.716 1.708-6.85 6.733-3.001-3.002-7.841 7.797 1.41 1.418 6.427-6.39 2.991 2.993 8.28-8.137 1.667 1.66 1.201-6.001z"
        }));

      case 'nogo':
        return /*#__PURE__*/React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: colourHex
        }, /*#__PURE__*/React.createElement("path", {
          d: "M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.597 17.954l-4.591-4.55-4.555 4.596-1.405-1.405 4.547-4.592-4.593-4.552 1.405-1.405 4.588 4.543 4.545-4.589 1.416 1.403-4.546 4.587 4.592 4.548-1.403 1.416z"
        }));

      default:
        return /*#__PURE__*/React.createElement("strong", null, "Error: no case in InlineSVG for ", name);
    }
  };

  return InlineSvg;
}(React.Component);

var _default = InlineSvg;
exports["default"] = _default;